<template>
  <div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modificarCliente"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Modificar Cliente</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <ClientesSelectComponent :current="current" />
              </div>
              <div v-if="current.cliente_nit" class="col-sm-12">
                <div class="form-group">
                  <label for>Nombre del Cliente</label>
                  <div class="input-group">
                    <input
                      id="cliente_nombre"
                      disabled
                      ref="cliente_nombre"
                      v-model="current.cliente_nit.nombre"
                      class="form-control"
                      placeholder="Nombre"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div v-if="current.cliente_nit" class="col-sm-12">
                <div class="form-group">
                  <label for>Dirección</label>
                  <div class="input-group">
                    <input
                      id="cliente_direccion"
                      disabled
                      ref="cliente_direccion"
                      v-model="current.cliente_nit.direccion"
                      class="form-control"
                      placeholder="Dirección"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div v-if="current.cliente_nit" class="col-sm-12">
                <div class="form-group">
                  <label for>Correo Electrónico</label>
                  <div class="input-group">
                    <input
                      id="email"
                      disabled
                      v-model="current.cliente_nit.email"
                      ref="email"
                      class="form-control"
                      placeholder="Correo Electrónico"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="updatePedido(current)">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modificarFormaPago"
      role="dialog"
      tabindex="-1"
      v-on:keyup.enter="updatePedido(current)"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Modificar Tipo Pago</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': current.errors && current.errors.tipo_pago,
                    }"
                    >Tipo de Pago</label
                  >
                  <div class="input-group">
                    <select
                      class="form-control"
                      v-model="currentTipo.tipo_pago"
                      required
                    >
                      <option value="CONTADO">Contado</option>
                      <option value="CREDITO">Crédito</option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tipo_pago"
                      class="form-text text-danger"
                      >{{ current.errors.tipo_pago[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="updatePedido(current)">
              Guardar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modificarPrecioLinea"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title text-center">Descuento de Precio</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" style="background-color: #aad7ff">
              <h6
                v-bind:class="{
                  'text-danger': errores && errores.usuario,
                }"
              >
                Autenticación
              </h6>
              <div
                v-bind:class="{
                  'text-danger': errores && errores.usuario,
                }"
                class="col-sm-12"
              >
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': errores && errores.usuario,
                    }"
                    >Usuario</label
                  >
                  <div class="input-group">
                    <input
                      class="form-control"
                      v-model="current.usuario"
                      type="text"
                      v-bind:class="{
                        'text-danger': errores && errores.usuario,
                      }"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': errores && errores.usuario,
                    }"
                    >Contraseña</label
                  >
                  <div class="input-group">
                    <input
                      v-bind:class="{
                        'text-danger': errores && errores.usuario,
                      }"
                      class="form-control"
                      v-model="current.clave"
                      required
                      type="password"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Nuevo precio</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      v-model="current.valor"
                      required
                      type="text"
                    />
                  </div>
                </div>
                <small class="text-danger" v-if="errores">{{ errores }}</small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="cambiarPrecioProducto()">
              Guardar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modificarPrecioSubtotal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title text-center">Descuento de Precio</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" style="background-color: #aad7ff">
              <h6
                v-bind:class="{
                  'text-danger': errores && errores.usuario,
                }"
              >
                Autenticación
              </h6>
              <div
                v-bind:class="{
                  'text-danger': errores && errores.usuario,
                }"
                class="col-sm-12"
              >
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': errores && errores.usuario,
                    }"
                    >Usuario</label
                  >
                  <div class="input-group">
                    <input
                      class="form-control"
                      v-model="current.usuario"
                      type="text"
                      v-bind:class="{
                        'text-danger': errores && errores.usuario,
                      }"
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger': errores && errores.usuario,
                    }"
                    >Contraseña</label
                  >
                  <div class="input-group">
                    <input
                      v-bind:class="{
                        'text-danger': errores && errores.usuario,
                      }"
                      class="form-control"
                      v-model="current.clave"
                      required
                      type="password"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Nuevo precio</label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      v-model="current.valor"
                      required
                      type="text"
                    />
                  </div>
                </div>
                <small class="text-danger" v-if="errores">{{ errores }}</small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="cambiarPrecioSubtotal()">
              Guardar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import CajaService from "@/services/cxc/CajaService";
import ClienteService from "@/services/catalogos/ClienteService";
import Notifications from "@/notifications/notifications";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import PedidosServices from "@/services/pos/PedidosServices";
import { mapGetters } from "vuex";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    UnidadMedidaSelectComponent,
    TiendaSelectComponent,
    ClientesSelectComponent,
  },
  data() {
    return {
      currentDetalle: {},
      form_pago: "",
      currentTipo: [],
      errores: "",
    };
  },
  props: {
    current: {
      type: Object,
    },
    detalle: {
      type: Object,
    },
  },
  watch: {},
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      clientes: "catalogos/clientes",
    }),
    unidad_medida() {
      this.refrescarPrecioVenta();
      return this.current.unidad_medida;
    },
  },
  mounted() {
    let self = this;
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    self.refreshCajas();
  },
  methods: {
    cambiarPrecioProducto() {
      DynamicService.postAction(
        "cxc",
        "pedidos",
        this.current.id,
        "cambiar_precio_linea",
        {
          id: this.detalle.id,
          usuario: this.current.usuario,
          clave: this.current.clave,
          valor: this.current.valor,
        }
      )
        .then((response) => {
          Notifications.alert.success(
            "cambiar Precio",
            "Realizado Correctamente"
          );
          this.$emit("refresh", {});
          $("#modificarPrecioLinea").modal("hide");
          this.current.usuario = "";
          this.current.clave = "";
          this.current.valor = "";
          this.errores = "";
        })
        .catch((errors) => {
          this.errores = errors.response.data;
        });
    },
    cambiarPrecioSubtotal() {
      DynamicService.postAction(
        "cxc",
        "pedidos",
        this.current.id,
        "cambiar_descuento",
        {
          id: this.detalle.id,
          usuario: this.current.usuario,
          clave: this.current.clave,
          valor: this.current.valor,
        }
      )
        .then((response) => {
          Notifications.alert.success(
            "cambiar Precio",
            "Realizado Correctamente"
          );
          this.$emit("refresh", {});
          $("#modificarPrecioLinea").modal("hide");
          this.current.usuario = "";
          this.current.clave = "";
          this.current.valor = "";
          this.errores = "";
        })
        .catch((errors) => {
          this.errores = errors.response.data;
        });
    },
    updatePedido(current) {
      current.tienda = current.tienda.codigo;
      if (this.currentTipo && this.currentTipo.tipo_pago) {
        this.current.tipo_pago = this.currentTipo.tipo_pago;
      }
      if (current.cliente_nit != current.cliente.nit) {
        current.cliente = current.cliente_nit.nit;
        current.cliente_nombre = current.cliente_nit.nombre;
        current.cliente_direccion = current.cliente_nit.direccion;
        current.cliente_nit = current.cliente_nit.nit;
      } else {
        current.cliente = current.cliente_nit;
      }
      current.caja = current.caja.id;
      DynamicService.save("cxc", "pedidos", current).then((response) => {
        Notifications.alert.success(
          "Modificar Datos de Pedido",
          "Realizado Correctamente"
        );
        this.$emit("refresh", {});
        $("#modificarFormaPago").modal("hide");
        $("#modificarCliente").modal("hide");
      });
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    refreshCajas() {
      let self = this;
      CajaService.fetch({
        tienda: self.current.tienda.codigo,
        quitar_paginacion: true,
      }).then((res) => {
        self.cajas = res.data;
      });
    },

    refreshCliente() {
      console.log(self.clientes);
    },

    onSearchCliente(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),

    guardarCliente(e) {
      e.preventDefault();
      let self = this;
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      if (current.lista_precio) {
        current.lista_precio = current.lista_precio.id;
      }
      ClienteService.save(current)
        .then((res) => {
          self.current.cliente_nit = res.data;
          self.current.errors = {};
          Notifications.alert.confirm(
            "Cliente Agregado exitosamente",
            "¿Desea continuar el pedido?",
            "Si",
            function () {
              self.$refs.cerrarModalCliente.click();
              $("#modalAddProductoPrecio").modal();
            }
          );
        })
        .catch((error) => {
          self.current.errors = Object.assign({}, error.response.data);
          if ("nit" in error.response.data) {
            Notifications.alert.error("Ups :(", error.response.data.nit[0]);
          }
        });
    },
  },
};
</script>
